import { render, staticRenderFns } from "./jd-md-price.vue?vue&type=template&id=ab0d2fe8&scoped=true&"
import script from "./jd-md-price.vue?vue&type=script&lang=js&"
export * from "./jd-md-price.vue?vue&type=script&lang=js&"
import style0 from "./jd-md-price.vue?vue&type=style&index=0&id=ab0d2fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0d2fe8",
  null
  
)

export default component.exports